import { autoserialize } from 'cerialize';

export class DriverStatus {
  @autoserialize
  driverId: number;

  @autoserialize
  currentReservationId: number;

  @autoserialize
  currentJourneyId: number;

  @autoserialize
  currentReservationStatusName: string;

  @autoserialize
  driverStatusName: string;
}
